import React from "react";
import "./About.css";
import { Link,withRouter} from "react-router-dom";
import Nav from "../Nav";
class About extends React.Component {
  render() {
    return (
      <div>
        <Nav/>
        <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/About">01 About Us</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Skills"> 02 Governance Structure</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">03 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Values"> 04 Our Core Values</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold'}}>THE WORLD LARGEST ECO-CITY DEVELOPER</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>At the Heart of the Global Circular Economy</p>
          <h3>Good Morning Bamboo Agro-Forestry and Investment Services.</h3>
        <p className="text-justify">Bamboo Eco-City is the first flagship Ecological City Development Project which is being implemented in Ghana. The project was conceived by the Founder of Good Morning Bamboo Agro-Forestry and Investments Services in January 2019, against the backdrop of the prevailing chronic housing deficit and rapid urbanization and increasing global attention on the importance of Green Buildings and Cities for sustainable development.<br/><br/>
Founded in September 2019 in Ghana, the Good Morning Bamboo Agro-Forestry and Investment Services (Good Morning Bamboo) is the master developer of the Bamboo Eco-City, led by lead by Engr. Samuel Kwaku Worwui. As master developer, Good Morning Bamboo works closely with the chiefs, local and national governments and private sectors in the emerging markets of the world, as well as other international partners, to plan and develop the world largest Eco-City.  Good Morning Bamboo is committed to building a sustainable Eco-City, an epitome of Green and Smart Cities; a model of sustainable development that showcases integrated ecological, commercial and industrial civilization with excellent efficiencies in renewable energy, sustainable water and waste resources management which is founded on innovation, collaboration, and strong governance resulting in vibrant circular economic activities in the cities and for their neighbouring communities.

</p>
        </div>
        <div class="card mb-3" style={{maxWidth: "540px;"}}>
  <div class="row no-gutters">
    <div class="col-md-4">
      <img src="https://i.imgur.com/xsMF07D.jpg" class="card-img" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <p class="card-text">GOOD MORNING BAMBOO ECO-CITY will be operated and anchored by GOOD MORNING BAMBOO AGRO-FORESTRY AND INVESTMENT SERVICES. The Company will build its Disruptive Innovation Centre Headquarters in GOOD MORNING BAMBOO ECO-CITY, as well as operate its Disruptive Innovative Construction Material manufacturing & Supply Chain Management Center from this hub..</p>
      </div>
    </div>
  </div>
</div>
<p>The project is strategically located in the Central Region of Ghana, a region known for its unmatched Tourism potentials and Pineapple and Citrus farming and Bamboo resources. It is expected that the project will be developed over three phases across a 200-Acre area.

<br/><br/><span style={{fontWeight: 'bold'}}>Development of the first phase will begin by June 2021. Interested investors can access the land by then.</span>
</p>
      </div>
        </div>
        <section  style={{backgroundColor: 'green'}} id="eplore-section" class=" py-5 text-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <img src="https://i.imgur.com/NinjaIt.png" alt="" class="img-fluid mb-3 rounded-circle"/>
        </div>
        <div class="col-md-6 mt-5">
          <h3>Mission Statement </h3>
          <p class=" text-justify drop ">To develop Bamboo ecological and
smart commercial, industrial &amp;
Tourism cities throughout the world
and place our tenants at the heart of
the circular economic market, by
providing a platform with world-class
integrated infrastructure and services
that helps facilitate the growth of our
customers’ businesses, and brings
sustained value to our cities and make
our cities positive contributors to
climate mitigation rather than Climate
Change.
</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mt-5">
        <h3>Our Vision </h3>
          <p class=" text-justify drop ">To be the epitome of Green and Smart Cities; a model of sustainable development – a model of integrated ecological, commercial, industrial,
Tourism civilization with excellent efficiencies in renewable energy, sustainable water and waste resources management which is founded on
disruptive innovative technologies, collaboration, and strong governance resulting in vibrant circular economic activities in the cities and for
their neighbouring communities.
</p>
        </div>
        <div class="col-md-6">
        <img src="https://i.imgur.com/lqB507l.png" alt="" class="img-fluid mb-3 rounded-circle"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <img src="https://i.imgur.com/NinjaIt.png" alt="" class="img-fluid mb-3 rounded-circle"/>
        </div>
        <div class="col-md-6 mt-5 text-light">
          <h3>Our Target Market</h3>
          <p class=" text-justify drop ">Our first target market is the Commercial, Industrial, Residential, Tourism, and Infrastructural Property Developers including
Information &amp; Telecommunication, Artificial Intelligence &amp; Robotics, Renewable Energy, Sustainable Water and Waste
Management.
Our second target market is the Low to Middle Income Earners working in the formal and informal sectors of the economy but
already living and struggling in existing cities in search for decent eco-homes to purchase.
Our last target market is the High Income Earners who wants to live in an ecological environment and enjoy their wealth in good
health.
</p>
        </div>
      </div>
      <div>
        <p style={{fontSize: '34px', marginTop: '5%'}}>Work, Live, Play, Train</p>
        <p style={{marginTop: '0'}}><br/>GOOD MORNING BAMBOO will be a fully integrated eco-
city. It is master planned to seamlessly intertwine industrial
areas, such as factories, workshops, yards, and the
Logistics Zone, with vibrant residential,
Training/educational, commercial and tourism areas.
<br/><br/>GOOD MORNING BAMBOO is a sustainable community,
one where residents want to live and learn, companies
want to build and prosper, employees want to work, and
visitors want to do business and enjoy tourism and
recreational facilities.
</p>
      </div>
    </div>
  </section>
 
        
      </div>
    )
  }
}
export default withRouter(About);
